<template>
  <q-dialog v-model="shown">
    <q-card style="min-width: 70%;">
      <q-card-section class="row items-center q-mx-xs">
        <div class="text-h6">
          Link To Library
        </div>
        <q-space />
        <q-btn
          v-close-popup
          icon="close"
          flat
          round
          dense
        />
      </q-card-section>
      <q-card-section>
        <model-table
          :collection="collection"
          selection="multiple"
          :columns="linkColumns"
          :cell-class="props => classesForRow(props.row)"
          :show-add="false"
          :show-edit="false"
          :edit-mode="true"
          row-key="id"
          @selected-input="selectedUpdate => selected = selectedUpdate"
        />
      </q-card-section>
      <q-card-actions class="row justify-end q-ma-sm">
        <q-btn
          :label="linkLabel"
          color="primary"
          :disable="selected.length === 0"
          :loading="loading"
          @click="linkItems"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import { Notify } from 'quasar'
import { defineAsyncComponent } from 'vue'

export default {
  name: 'LibraryDialog',
  components: {
    ModelTable: defineAsyncComponent(() => import('src/modules/admin/components/ModelTable'))
  },
  props: {
    modelValue: {
      type: Boolean,
      required: false
    },
    columns: {
      type: Array,
      required: false,
      default: null
    },
    collection: {
      type: Object,
      required: true
    },
    options: {
      type: Array,
      required: false,
      default: () => ([])
    },
    filter: {
      type: Function,
      required: false,
      default: () => {}
    }
  },
  emits: ['update:model-value', 'linked'],
  data () {
    return {
      shown: false,
      selected: [],
      loading: false
    }
  },
  computed: {
    linkLabel () {
      return `Link ${this.selected.length === 1 ? this.collection.humanTypeName : this.collection.humanCollectionName} to the Library (${this.selected.length})`
    },
    linkColumns () {
      if (this.columns) return this.columns

      return [
        { field: 'id' },
        { field: _.has(this.collection, 'name') ? 'name' : 'title' },
        {
          field: 'libraryParentId',
          label: `Library ${this.collection.humanTypeName}`,
          editor: {
            component: 'select',
            options: this.options,
            mapOptions: true,
            optionLabel: _.has(this.collection, 'name') ? 'name' : 'title',
            optionValue: 'id',
            emitValue: true,
            label: this.collection.humanTypeName,
            filterFunction: this.filter,
            clearable: true
          },
          headerStyle: 'vertical-align: bottom; width: 30%',
          style: 'width: 30%'
        }
      ]
    }
  },
  watch: {
    modelValue () {
      this.shown = this.modelValue
    },
    shown () {
      this.$emit('update:model-value', this.shown)
      this.greyoutRows()
    }
  },
  methods: {
    show () {
      this.shown = true
    },
    classesForRow (libraryModel) {
      const addedLibraryIds = _.map(this.collection.data, 'libraryParentId')
      const alreadyAdded = _.includes(addedLibraryIds, libraryModel.id)
      if (alreadyAdded) {
        return ['tr-bg-grey-4', 'bg-grey-4']
      } else {
        return []
      }
    },
    greyoutRows () {
      // Hacky way to set the row background. There isn't direct support for it in Quasar. There is for td but it doesn't set the selected td background
      if (this.shown) {
        this.$nextTick(() => {
          _.each(document.getElementsByClassName('tr-bg-grey-4'), el => {
            el.parentElement.style = 'background: #DDD'
          })
        })
      }
    },
    async linkItems () {
      if (!this.selected.length) return

      const ids = _.map(this.selected, model => model.libraryParentId ? [model.id, model.libraryParentId] : model.id)

      this.loading = true
      const model = new this.collection.constructor()
      const { errors } = await model.linkOrPromote(ids)
      this.loading = false

      if (errors && errors.length > 0) {
        Notify.create({
          message: 'Error linking items',
          type: 'negative',
          position: 'top'
        })
        console.log(errors)
      } else {
        this.$emit('linked')
        this.shown = false
      }
    }
  }
}

</script>

<style lang="scss" scoped>
</style>
